import React, { useEffect, useState } from "react";
import { Card, Radio } from "antd";
import ReactApexChart from "react-apexcharts";
import { viewModes } from "../../pages/Home";

function RewardAnalysisCard({
  invoices,
  loading,
  availableYears,
  selectedYear,
  setSelectedYear,
  setViewMode,
  viewMode,
}) {
  const [chartOptions, setChartOptions] = useState({
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: true },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: "55%",
        },
      },
      xaxis: {
        categories: [],
        title: { text: "Période" },
      },
      yaxis: {
        title: { text: "Récompenses Distribuées" },
      },
      title: {
        text: "Analyse des Récompenses",
        align: "left",
      },
      colors: ["#52c41a"],
      tooltip: {
        y: {
          formatter: (val) => val,
        },
      },
    },
    series: [],
  });

  useEffect(() => {
    const calculateRewardData = () => {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const monthlyRewards = months.map((month, index) => {
        const monthInvoices = invoices.filter((inv) => {
          const date = new Date(inv.date);
          return (
            date.getFullYear() === selectedYear &&
            date.getMonth() === index &&
            inv.recompenseOption
          );
        });
        return {
          month,
          rewardCount: monthInvoices.length,
        };
      });

      const yearlyRewards = invoices.reduce((acc, invoice) => {
        const year = new Date(invoice.date).getFullYear();
        if (invoice.recompenseOption) {
          acc[year] = (acc[year] || 0) + 1;
        }
        return acc;
      }, {});

      const categories =
        viewMode === viewModes.MONTHLY
          ? monthlyRewards.map((d) => d.month)
          : Object.keys(yearlyRewards);

      const series =
        viewMode === viewModes.MONTHLY
          ? [
              {
                name: "Récompenses Distribuées",
                data: monthlyRewards.map((d) => d.rewardCount),
              },
            ]
          : [
              {
                name: "Récompenses Distribuées",
                data: Object.values(yearlyRewards),
              },
            ];

      // ✅ Update chart options dynamically
      setChartOptions((prev) => ({
        ...prev,
        series: series ?? [],
        options: {
          ...prev.options,
          chart: {
            ...prev.options.chart,
            type: "bar",
          },
          xaxis: {
            ...prev.options.xaxis,
            categories: categories ?? [],
          },
          title: {
            ...prev.options.title,
            text:
              viewMode === "yearly"
                ? "Analyse Annuelle des Récompenses"
                : `Analyse Mensuelle des Récompenses ${
                    selectedYear ? `(Année: ${selectedYear})` : ""
                  }`,
          },
        },
      }));
    };

    if (invoices.length > 0) {
      calculateRewardData();
    }
  }, [invoices, viewMode, selectedYear]);

  return (
    <Card
      title="Analyse des Récompenses"
      bordered={false}
      loading={loading}
      style={{ marginBottom: 24 }}
      extra={
        <div style={{ display: "flex", gap: 16 }}>
          <Radio.Group
            value={viewMode}
            onChange={(e) => setViewMode(e.target.value)}
            buttonStyle="solid"
          >
            <Radio.Button value={viewModes.MONTHLY}>Mensuel</Radio.Button>
            <Radio.Button value={viewModes.YEARLY}>Annuel</Radio.Button>
          </Radio.Group>

          {viewMode === viewModes.MONTHLY && (
            <Radio.Group
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              buttonStyle="solid"
            >
              {availableYears.map((year) => (
                <Radio.Button key={year} value={year}>
                  {year}
                </Radio.Button>
              ))}
            </Radio.Group>
          )}
        </div>
      }
    >
      <ReactApexChart
        options={chartOptions.options}
        series={chartOptions.series}
        type="bar"
        height={350}
      />
    </Card>
  );
}

export default RewardAnalysisCard;
